import { useContext } from 'react';
import { createNamedContext } from '@utils';
import { TranscribeRT } from '@/types';
import { Transcript } from './interfaces';

export const TranscriptHighlightsContext = createNamedContext<TranscribeRT.Highlight[]>(undefined, 'TranscriptHighlightsContext');
export const TranscriptHighlightActionsContext = createNamedContext<Transcript.HighlightActions>(undefined, 'TranscriptHighlightActionsContext');

export const useTranscriptHighlights = () => useContext(TranscriptHighlightsContext);
export const useTranscriptHighlightActions = () => useContext(TranscriptHighlightActionsContext);